import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { RootState } from './slices';
import type { AppDispatch } from './index';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
